import { render, staticRenderFns } from "./FormNino.vue?vue&type=template&id=c6d2b718"
import script from "./FormNino.vue?vue&type=script&lang=js"
export * from "./FormNino.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports